import _ from 'lodash'
import {updateSiteSettings} from '../../commons/actions/site-settings'
import {getFirstEvent} from '../selectors/events'
import {GetState} from '../types/state'
import {updateComponentDraft, updateComponentTexts, updateStyleParams, INJECT_COMPONENT_DRAFT} from './component'
import {textsSectionChanged} from './fonts-panel'
import {closeListLayoutItems, hideRibbonOnItems, openListLayoutItem, showRibbonOnItems} from './layout'
import {forceResize} from './resize'
import {settingsSectionChanged, settingsTabChanged} from './settings-panel'

export enum SettingsUpdatedActionType {
  SETTINGS = 'SETTINGS',
  SITE_SETTINGS = 'SITE_SETTINGS',
  // eslint-disable-next-line no-shadow
  INJECT_COMPONENT_DRAFT = 'INJECT_COMPONENT_DRAFT',
  RESIZE = 'RESIZE',
  EXPAND_EVENT = 'EXPAND_EVENT',
  COLLAPSE_EVENT = 'COLLAPSE_EVENT',
  NAVIGATE_TO_PAGE = 'NAVIGATE_TO_PAGE',
  SETTINGS_TAB_CHANGED = 'SETTINGS_TAB_CHANGED',
  SETTINGS_SECTION_CHANGED = 'SETTINGS_SECTION_CHANGED',
  TEXTS_SECTION_CHANGED = 'TEXTS_SECTION_CHANGED',
  SHOW_RIBBON = 'SHOW_RIBBON',
  HIDE_RIBBON = 'HIDE_RIBBON',
}

interface SettingsUpdateAction {
  type: SettingsUpdatedActionType
  [key: string]: any
}

export const updateSettings = (action: SettingsUpdateAction) => (dispatch: Function, getState: GetState) => {
  switch (action.type) {
    case SettingsUpdatedActionType.SETTINGS:
      debouncedUpdateComponentDraft(action.type, getState, action, dispatch)
      dispatch(updateComponentTexts(action.settings.texts))
      break
    case SettingsUpdatedActionType.SITE_SETTINGS:
      dispatch(updateSiteSettings(action.settings))
      break
    case SettingsUpdatedActionType.INJECT_COMPONENT_DRAFT:
      dispatch({
        type: INJECT_COMPONENT_DRAFT,
        payload: action.payload,
        newest: true,
      })
      break
    case SettingsUpdatedActionType.SHOW_RIBBON:
      dispatch(showRibbonOnItems())
      break
    case SettingsUpdatedActionType.HIDE_RIBBON:
      dispatch(hideRibbonOnItems())
      break
    case SettingsUpdatedActionType.EXPAND_EVENT:
      {
        const event = getFirstEvent(getState())
        if (event) {
          dispatch(openListLayoutItem(event.id))
        }
      }
      break
    case SettingsUpdatedActionType.COLLAPSE_EVENT:
      dispatch(closeListLayoutItems())
      break
    case SettingsUpdatedActionType.SETTINGS_TAB_CHANGED:
      dispatch(settingsTabChanged(action.tab))
      break
    case SettingsUpdatedActionType.SETTINGS_SECTION_CHANGED:
      dispatch(settingsSectionChanged(action.id))
      break
    case SettingsUpdatedActionType.TEXTS_SECTION_CHANGED:
      dispatch(textsSectionChanged(action.id))
      break
    case SettingsUpdatedActionType.RESIZE:
      dispatch(forceResize())
      break
    default:
      break
  }
}

export const updateStyle = (params: any) => (dispatch: Function) => {
  return dispatch(updateStyleParams(params))
}

const debouncedUpdateComponentDraft = _.debounce((type: string, getState: GetState, action, dispatch: Function) => {
  const state = getState()
  const obsoleteKeys = [
    'closedRegistrationMessages',
    'messages',
    'shoutoutTemplateClicked',
    ...Object.keys(state.component.params),
  ]
  const compSettings = _.omit(action.settings, obsoleteKeys)

  dispatch(updateComponentDraft(type, {settings: compSettings}))
}, 1000)
